export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img6-8da93b4659288118ebb9ceacee3b000f.png";